import * as z from 'zod';

// Types
import { blocksSchemaZod } from '@/components/blocks/Blocks';
import { SeoTitleTagZod } from '@/types/SeoTitleTag';
import { MediaZod } from '@/types/MediaType';
import { TagZod } from '@/types/TagType';
import { AuthorZod } from '@/types/Blog/AuthorType';
import { CategoryZod } from '@/types/Blog/CategoryType';

const ArticleZod = z.object({
  id: z.number(),
  documentId: z.string(),
  slug: z.string(),
  title: z.string(),
  SeoTitleTag: SeoTitleTagZod,
  description: z.string().nullish(),
  cover: MediaZod.nullish(),
  get author() {
    return AuthorZod.nullish();
  },
  get category() {
    return CategoryZod.nullish();
  },
  date: z.string(),
  tags: z.array(TagZod).nullable(),
  blocks: z.array(blocksSchemaZod),
});

export type ArticleType = z.infer<typeof ArticleZod>;

const ArticlesZod = z.array(ArticleZod);

export type ArticlesType = z.infer<typeof ArticlesZod>;

export { ArticleZod, ArticlesZod };
